var map = {
	"./about.svg": "/mzh",
	"./achievement.svg": "SOLA",
	"./amap.svg": "Ct1/",
	"./arrow-down.svg": "Peom",
	"./arrow-left.svg": "INtk",
	"./arrow-right.svg": "dxdv",
	"./arrow-up.svg": "P3Ow",
	"./baidu.svg": "cvyf",
	"./close.svg": "toIl",
	"./delete.svg": "Imjp",
	"./google.svg": "YgBy",
	"./jnq.svg": "02hX",
	"./jnq_en.svg": "00Ku",
	"./logout.svg": "KvOj",
	"./map-full.svg": "XvX1",
	"./map-window.svg": "+fYs",
	"./password-show.svg": "EDi2",
	"./password.svg": "QjmH",
	"./qjt.svg": "BXAn",
	"./record.svg": "1XyD",
	"./relocate.svg": "+Ie+",
	"./return-index.svg": "mOLs",
	"./review.svg": "3epJ",
	"./search.svg": "Bx0U",
	"./settings.svg": "rPJQ",
	"./share.svg": "BDVe",
	"./username.svg": "QS/K"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 3